import { Injectable } from '@angular/core';
import { EnvConfigurationService } from '../envconf/envconf.service';
import { map, Observable, of } from 'rxjs';
import { UserDto, UserNoIdDto, UserSimpleDto } from '../../models/user/user-dto';
import { HttpClient } from '@angular/common/http';
import { PaginatedResponse, PaginatorFilters } from '@michelin/theme';
import { ApiService } from '../api/api.service';
import { Pagination } from '../../models/pagination';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  endpoint = `${EnvConfigurationService.configuration.BACKEND_URL}${EnvConfigurationService.configuration.BACKEND_SUB_PATH}/users`;

  constructor(private readonly http: HttpClient, private readonly apiService: ApiService) {}

  getPaginatedResponse(pagination: Pagination<UserSimpleDto>): PaginatedResponse<UserSimpleDto> {
    return {
      count: pagination.totalElements,
      items: pagination.content
    };
  }

  search(paginatorFilters?: PaginatorFilters): Observable<PaginatedResponse<UserSimpleDto>> {
    return this.http
      .get<PaginatedResponse<UserSimpleDto>>(`${this.endpoint}${this.apiService.getQueryParams(paginatorFilters)}`)
      .pipe(map((items: Pagination<UserSimpleDto>) => this.getPaginatedResponse(items)));
  }

  findAll(): Observable<UserDto[]> {
    return this.http.get<UserDto[]>(`${this.endpoint}/all`);
  }

  findById(userId: number): Observable<UserDto> {
    return this.http.get<UserDto>(`${this.endpoint}/${userId}`);
  }

  create(data: UserNoIdDto): Observable<UserDto> {
    return this.http.post<UserDto>(this.endpoint, data);
  }

  update(userId: number, data: UserNoIdDto): Observable<UserDto> {
    return this.http.put<UserDto>(`${this.endpoint}/${userId}`, data);
  }
}
